export default __webpack_public_path__ + "static/media/fileStructure.31094e05.png";